import { Vector2 } from '@babylonjs/core';
import Element, { ElementType } from '../element';
import store from '@/store';
import { stringUtil } from '../stringUtil';
import { ShaderNPodp } from '../shaders/legs/shader_n_podp';
import { BaseCommand } from './baseCommand';
import { Legs } from '../legs/legs';
import { ChangeKeaRingCommand } from './changeKeaRingCommand';
import { HandleLegsSupportCommand } from './handleLegsSupportCommand';

export default class ChangeLegsCommand extends BaseCommand {

    private previous!: Element[];
    private previousLegs!: Legs;
    private body!: Element;

    constructor(
        scenePreview: any,
        private legs: Legs,
    ) {
        super(scenePreview);
    }

    public execute(): void {
        this.saveState();
        this.changeKeaRingModel();
        this.changeLegsModel();
        this.changeLegsSupportModel();
    }

    public revert(): void {
        store.commit('selectLegs', this.previousLegs);
        this.removeElements();
        this.revertCommands();
        this.previous.forEach((x) => {
            x.isVisible = true;
            this.scenePreview.elements.push(x);
        });
    }

    private saveState() {
        this.previousLegs = store.getters.shaders.selectedLegs;
        store.commit('selectLegs', this.legs);
        this.previous = this.scenePreview.elements
            .filter((x: Element) =>
                x.type === ElementType.LEGS &&
                x.isVisible &&
                x.shaderName !== 'ShaderNPodp',
            );
        this.body = this.scenePreview.elements
            .find((x: Element) => x.type === ElementType.BODY);
    }

    private changeLegsModel() {
        const model = stringUtil.fillLegsPath(this.legs.model);
        const light = stringUtil.fillLegsPath(this.legs.light);
        this.scenePreview.addElement(
            model,
            light,
            this.legs.shader,
            Vector2.Zero(),
            Vector2.Zero(),
            (element: Element) => {
                this.previous.forEach((x) => {
                    x.isVisible = false;
                    this.scenePreview.elements.splice(
                        this.scenePreview.elements.indexOf(x), 1,
                    );
                });
                this.elements.push(element);
            });
    }

    private changeKeaRingModel() {
        const command = new ChangeKeaRingCommand(this.scenePreview, this.legs);
        this.addCommand(command);
    }

    private changeLegsSupportModel() {
        const command = new HandleLegsSupportCommand(this.scenePreview);
        this.addCommand(command);
    }
}
